import { classnames } from '@aibees/shared/utils';
import { TextField, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { FormFieldsProps as Props } from './types';

export const FormFields = memo(
  ({ className, label, value, onChange, error }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('FormFields', className)}
        sx={SX.root}
        gap={0.5}
      >
        <Typography variant="body3" fontWeight={600} color="grey.700">
          {label}
        </Typography>
        <TextField
          placeholder="Number"
          fullWidth
          size="small"
          type={'Number'}
          inputProps={{
            min: 0,
            step: 1,
          }}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error}
        />
      </Styled.Wrapper>
    );
  }
);

FormFields.displayName = 'FormFields';
